import { Image, Skeleton } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'

type ImageProps = {
  src: string
  setIsImageLoaded: React.Dispatch<React.SetStateAction<boolean>>
}

const ImageWithRetry: React.FC<ImageProps> = ({ src, setIsImageLoaded }) => {
  const [imageSrc, setImageSrc] = useState<string>(src)
  const [retryCount, setRetryCount] = useState<number>(0)

  const handleError = () => {
    if (retryCount < 10) {
      setIsImageLoaded(false)
      setRetryCount(retryCount + 1)
      setTimeout(() => {
        setImageSrc('')
        setImageSrc(src)
      }, 10000)
    }
  }

  useEffect(() => {
    setImageSrc(src)
    setRetryCount(0)
  }, [src])

  return (
    <Image
      borderRadius="8px"
      src={imageSrc}
      fallback={<Skeleton borderRadius="8px" />}
      onError={handleError}
      onLoad={() => setIsImageLoaded(true)}
    />
  )
}

export default ImageWithRetry
